var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApprovedGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8131)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4253 18.5803C35.0499 18.205 34.5408 17.9941 34.01 17.9941C33.4791 17.9941 32.97 18.205 32.5946 18.5803L24.0001 27.174L20.4107 23.5856C20.226 23.3944 20.0051 23.2418 19.7609 23.1369C19.5166 23.032 19.2539 22.9768 18.9881 22.9745C18.7223 22.9722 18.4587 23.0228 18.2126 23.1235C17.9666 23.2241 17.7431 23.3728 17.5551 23.5607C17.3671 23.7487 17.2185 23.9722 17.1178 24.2183C17.0172 24.4643 16.9665 24.7279 16.9688 24.9937C16.9711 25.2596 17.0264 25.5222 17.1313 25.7665C17.2362 26.0107 17.3887 26.2316 17.5799 26.4163L22.5848 31.4211C22.7706 31.6071 22.9913 31.7546 23.2341 31.8553C23.477 31.9559 23.7373 32.0077 24.0002 32.0077C24.2631 32.0077 24.5234 31.9559 24.7663 31.8553C25.0091 31.7546 25.2298 31.6071 25.4156 31.4211L35.4253 21.4113C35.8007 21.0359 36.0116 20.5267 36.0116 19.9958C36.0116 19.4649 35.8007 18.9557 35.4253 18.5803Z",
    fill: "#4DDD37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0215 22.9981C46.4906 22.9984 45.9815 23.2093 45.6061 23.5847C45.2307 23.9601 45.0197 24.4692 45.0195 25.0001C45.0195 36.0389 36.0388 45.0196 25 45.0196C13.9612 45.0196 4.98047 36.0389 4.98047 25.0001C4.98047 13.9613 13.9612 4.98057 25 4.98057C27.6422 4.97298 30.2594 5.49205 32.6987 6.50744C35.138 7.52283 37.3505 9.01417 39.2068 10.8943C39.3909 11.0861 39.6112 11.2393 39.8551 11.345C40.0989 11.4506 40.3614 11.5067 40.6271 11.5099C40.8929 11.5131 41.1566 11.4634 41.4029 11.3636C41.6492 11.2638 41.8732 11.1159 42.0618 10.9287C42.2504 10.7414 42.3998 10.5185 42.5013 10.2729C42.6029 10.0273 42.6545 9.76388 42.6531 9.49812C42.6518 9.23236 42.5976 8.96951 42.4936 8.72493C42.3896 8.48034 42.238 8.25891 42.0476 8.07353C39.82 5.8173 37.1652 4.02764 34.2381 2.80911C31.3111 1.59059 28.1705 0.967635 25 0.976659C11.753 0.976659 0.976562 11.7531 0.976562 25.0001C0.976562 38.2471 11.753 49.0235 25 49.0235C38.247 49.0235 49.0234 38.2471 49.0234 25.0001C49.0232 24.4692 48.8122 23.9601 48.4369 23.5847C48.0615 23.2093 47.5524 22.9984 47.0215 22.9981Z",
    fill: "#4DDD37"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedGreen);
export default __webpack_public_path__ + "static/media/approved_green.728db6a64a0689fc7a01e98e18caf789.svg";
export { ForwardRef as ReactComponent };